module.exports = __webpack_public_path__ + "static/media/cover-title.a463577b.png";